import _ from 'lodash'

import { baseApi, Tag } from './base'
import { PatientQueue, AddPatientToQueueDto, ReorderItemDto } from '@/core/models/patient-queue.model'

export const patientQueueApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPatientQueueByStaff: builder.query<PatientQueue, void>({
      query: () => `/patient-queue/staff`,
      providesTags: (result) => (result ? [{ type: Tag.PATIENT_QUEUE, id: result._id }] : []),
    }),

    addPatientToQueue: builder.mutation<PatientQueue, AddPatientToQueueDto>({
      query: (addPatientDto) => ({
        url: '/patient-queue/add-patient',
        method: 'POST',
        body: addPatientDto,
      }),
      invalidatesTags: (result) => (result ? [{ type: Tag.PATIENT_QUEUE, id: result._id }] : []),
    }),

    removePatientFromQueue: builder.mutation<PatientQueue, string>({
      query: (patientId) => ({
        url: `/patient-queue/patient/${patientId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result) => (result ? [{ type: Tag.PATIENT_QUEUE, id: result._id }] : []),
    }),

    reorderQueuedPatients: builder.mutation<PatientQueue, ReorderItemDto>({
      query: (items) => ({
        url: '/patient-queue/reorder',
        method: 'PATCH',
        body: items,
      }),
      async onQueryStarted(items, { dispatch, queryFulfilled }) {
        const patientPositionMap = new Map(items.map((item) => [item.patientId, item.position]))
        const patchResult = dispatch(
          patientQueueApi.util.updateQueryData('getPatientQueueByStaff', undefined, (draft) => {
            for (const queueEntry of draft.queue) {
              queueEntry.position = patientPositionMap.get(queueEntry.patient._id) ?? queueEntry.position
            }
          })
        )
        try {
          await queryFulfilled
        } catch {
          patchResult.undo()
        }
      },
      // invalidatesTags: (result) => (result ? [{ type: Tag.PATIENT_QUEUE, id: result._id }] : []),
    }),
  }),
  overrideExisting: false,
})
